module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-87.14a751ed.svg";